import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};
// ✅ Get Admin Accounts List
export const getAdminAccountsList = async () => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get("/admin/get-admin-accounts-list", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
    /*
      expected:
      {
        data: [
          {
            id,
            name,
            username,
            email,
            role,
            is_active,
            permissions: {...}
          }
        ]
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Get Admin Account Details
export const getAdminAccountDetails = async (adminId) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get(
      `/admin/get-admin-account-details/${adminId}`,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    /*
      expected:
      {
        data: {
          id,
          name,
          username,
          email,
          role,
          is_active,
          permissions: {...}
        }
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Create Admin Account
export const createAdminAccount = async (payload) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  try {
    const res = await api.post(
      "/admin/create-admin-account",
      payload,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    /*
      expected:
      {
        data: {
          name,
          username,
          role,
          phone,
          ...
        }
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Update Admin Account
export const updateAdminAccount = async (adminId, payload) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  try {
    const res = await api.post(
      `/admin/update-admin-account/${adminId}`,
      payload,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    /*
      expected:
      {
        data: {
          id,
          name,
          username,
          role,
          phone,
          ...
        }
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Change Admin Account Status (Activate / Deactivate)
export const changeAdminAccountStatus = async (adminId) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get(
      `/admin/change-admin-account-status/${adminId}`,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    /*
      expected:
      {
        data: { ...admin, is_active: 0 أو 1 },
        message: "تم تغيير حالة الحساب بنجاح"
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Update Admin Permissions
export const manageAdminAccountPermissions = async (
  adminId,
  permissions
) => {
  const headers = {
    ...getAuthHeaders(),
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  try {
    const res = await api.post(
      `/admin/manage-admin-account-permissions/${adminId}`,
      permissions,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    /*
      expected:
      {
        data: {
          id,
          user_id,
          add,
          edit,
          delete,
          view,
          print,
          export
        },
        message: "تم إضافة أو تحديث الصلاحيات بنجاح"
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};